import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { hashCode } from '@lib/string';
import { useTheme } from '@components/theme';
import styles from './Breadcrumb.module.scss';

export interface BreadcrumbItem {
  label: string;
  url: string;
}

interface IBreadcrumbProps {
  className?: string;
  items: BreadcrumbItem[];
}

const Breadcrumb = ({
  className = '',
  items = [],
}: IBreadcrumbProps) => {
  const theme = useTheme();

  return (
    <div className={classNames(
      className,
      styles.Breadcrumb,
      theme.styles.Caption
    )}
    >
      {
        items.map(({ label, url }, index) => (
          <span key={hashCode(url)}>
            {(index > 0) ? <span className={styles.Divider}>/</span> : undefined}
            <span className={classNames({ [styles.Active]: index === items.length - 1 })}>
              <Link href={url}>{label}</Link>
            </span>
          </span>
        ))
      }
    </div>
  );
};

export default Breadcrumb;
